export default {"src":"/_next/static/media/json-svgrepo-com.0eb4571d.svg","height":303,"width":303,"blurWidth":0,"blurHeight":0};